export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';

export default {};



// WEBPACK FOOTER //
// ./src/services/notification/actionTypes.js